export default __webpack_public_path__ + "static/media/flag_en.ad3aa4f8.svg";